import styled from 'styled-components'

export const ItemWrapper = styled.li`
    margin-bottom: 16px;
`
